<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="disabled ? '详情' : snRule.pkid ? '编辑' : '新建'"
      width="1100px"
      class="adaptationModal"
      @close="$reset('form')"
  >
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="snRule"
        :rules="ruleValidate"
        class="form"
        :disabled="disabled"
        label-width="80px"
    >
      <div class="editTitle">基本信息</div>
      <el-row>
        <el-col v-if="snRule.pkid" :span="12">
          <el-form-item label="规则编号" prop="snRuleNo">
            <el-input v-model="snRule.snRuleNo" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="规则类型" prop="snType">
            <el-select v-model="snRule.snType" placeholder="请选择规则类型">
              <el-option label="产品条码" :value="10"/>
              <el-option label="外箱条码" :value="20"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="规则样式" prop="snRuleExpression">
            <el-input v-model.trim="snRule.snRuleExpression" placeholder="请输入规则样式"/>
          </el-form-item>
        </el-col>
        <el-col v-if="snRule.snRuleExpression" :span="12">
          <el-form-item label="字符总数">
            <el-input v-model="snRule.snLength" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="规则状态" prop="status">
            <el-select v-model="snRule.status" placeholder="请选择规则状态">
              <el-option label="待确认" :value="10"/>
              <el-option label="已确认" :value="20"/>
              <el-option label="已作废" :value="90"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="规则描述" prop="snRuleExpressionDesc">
            <el-input v-model="snRule.snRuleExpressionDesc" autosize type="textarea" placeholder="请输入规则描述"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="备注">
            <el-input v-model="snRule.snRuleDesc" autosize type="textarea" placeholder="请输入"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="isDefault" label="默认">
            <el-switch v-model="snRule.isDefault" :active-value="true" :inactive-value="false"/>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="editTitle">元码信息</div>
      <el-button type="primary" style="margin-bottom: 8px" @click="$refs.barCodeRulesDetailsEdit.open()"> 添加 </el-button>
      <Table border :columns="columns" :data="snRule.snRuleDetails">
        <template slot="action" slot-scope="{ index }">
          <el-button type="danger" @click="snRule.snRuleDetails.splice(index, 1)">删除</el-button>
        </template>
      </Table>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
    <bar-code-rules-details-edit ref="barCodeRulesDetailsEdit" @save-success="getCodeDetail"/>
  </el-dialog>
</template>

<script>
  import BarCodeRulesDetailsEdit from "./BarCodeRulesDetailsEdit.vue";
  export default {
    components: {
      BarCodeRulesDetailsEdit,
    },
    data() {
      return {
        disabled: false,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        snRule: {
          pkid: 0,
          snRuleNo: "",
          snType: "",
          snRuleExpression: "",
          snLength: "",
          status: "",
          snRuleExpressionDesc: "",
          snRuleDesc: "",
          snRuleDetails: [],
          isDefault: false,
        },
        ruleValidate: {
          snType: { required: true, message: "请选择规则类型", trigger: "change" },
          status: { required: true, message: "请选择规则状态", trigger: "change" },
          snRuleExpression: { required: true, message: "请输入规则样式", trigger: "blur" },
          snRuleExpressionDesc: { required: true, message: "请输入规则描述", trigger: "blur" },
        },
        columns: [
          {
            title: "元码编号",
            key: "metaDataNo",
            minWidth: 300,
          },
          {
            title: "元码标签",
            key: "metaDataLable",
            width: 120,
            align: "center",
          },
          {
            title: "元码名称",
            key: "metaDataName",
            width: 120,
            align: "center",
          },
          {
            title: "标签个数",
            key: "lableLength",
            width: 90,
            align: "center",
          },
          {
            title: "数据源",
            key: "dataSource",
            width: 100,
            align: "center",
          },
          {
            title: "后缀",
            key: "suffixChar",
            width: 100,
            align: "center",
          },
          {
            title: "是否验证",
            key: "isVerify",
            width: 100,
            align: "center",
            render: (h, params) => {
              return h("span", params.row.isVerify ? "是" : "否");
            },
          },
          {
            title: "操作",
            slot: "action",
            width: 80,
            align: "center",
            fixed: "right",
          },
        ],
      };
    },
    watch: {
      "snRule.snRuleExpression": {
        handler(value) {
          this.snRule.snLength = value.length;
        },
      },
    },

    methods: {
      open(row, mark) {
        this.dialogVisible = true;
        this.disabled = !!mark;
        if (row) {
          this.getData(row.pkid);
        }
      },

      getCodeDetail(row) {
        console.log(row);
        row.metaDataDesc = row.metaDataNo;
        this.snRule.snRuleDetails.push(row);
        console.log(this.snRule.snRuleDetails);
      },

      getData(pkid) {
        this.contentLoading = true;
        this.$http
          .get("basic", `snRule/${pkid}`)
          .then((resp) => {
            if (resp.success) {
              this.snRule = Object.assign(this.snRule, resp.data);
              this.contentLoading = false;
            }
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (!this.snRule.snRuleDetails.length) {
              this.$confirm("元码信息不能为空", "错误", {
                type: "error",
                showCancelButton: false,
              });
            } else {
              this.submitLoading = true;
              this.$http
                .save("basic", "snRule", this.snRule)
                .then((resp) => {
                  if (resp.success) {
                    if (this.snRule.pkid) {
                      this.$emit("save-success");
                      this.$message.success("编辑成功");
                    } else {
                      this.$emit("save-success");
                      this.$message.success("添加成功");
                    }
                    this.dialogVisible = false;
                  }
                  this.submitLoading = false;
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
          }
        });
      },
    },
  };
</script>
